// extracted by mini-css-extract-plugin
export default {"userBadge":"userBadge_userBadge__1hHPp","userBadgeButton":"userBadge_userBadgeButton__lJPgN"};